const ACCESS_AUTH = 'PARTNER_EIS_ACCESS_AUTH'
const PARTNER_MALL_APP_INFO = 'PARTNER_EIS_APP_INFO'
const AUTH = JSON.parse(localStorage.getItem(ACCESS_AUTH)) || {}
const APP_INFO = JSON.parse(localStorage.getItem(PARTNER_MALL_APP_INFO)) || {}

const module = {
  namespaced: true,
  state: {
    targetKey: AUTH.targetKey || '',
    token: AUTH.token || '',
    appInfo: APP_INFO
  },
  getters: {
  },
  mutations: {
    setData (state, data) {
      state.targetKey = data.targetKey
      state.token = data.token
      localStorage.setItem(ACCESS_AUTH, JSON.stringify(data))
    },
    clearData (state) {
      state.targetKey = ''
      state.token = ''
      localStorage.removeItem(ACCESS_AUTH)
    },
    setAppInfo (state, data) {
      localStorage.setItem(PARTNER_MALL_APP_INFO, JSON.stringify(data))
    },
    clearAppInfo (state) {
      localStorage.removeItem(PARTNER_MALL_APP_INFO)
    }
  }
}
export default module



// WEBPACK FOOTER //
// ./src/store/modules/auth.js